import React, { useEffect } from "react";
import GlobalScripts from "./components/GlobalScripts";
import SEO from "./components/SEO";
import ScrollToTop from "./components/ScrollToTop";
import "./App.css";
import Menu from "./components/Menu/Menu";
import { Routes, Route, useLocation } from "react-router-dom";

import DesarrolloWeb from "./pages/DesarrolloWeb";
import CMS from "./pages/CMS";
import Ecommerce from "./pages/Ecommerce";
import IA from "./pages/IA";
import Marketing from "./pages/Marketing";
import Optimizacion from "./pages/Optimizacion";
import Home from "./pages/Home";

// 1. Definimos el rastreador SIN usar "export default" aquí
function VisitorTracker() {
  useEffect(() => {
    // Evitar que se envíen múltiples registros si la persona recarga la página
    if (sessionStorage.getItem("visitaRegistrada")) {
      return; 
    }

    const registrarVisita = async () => {
      // Recopilamos datos del lado del cliente
      const dataToSend = {
        pagina: window.location.href,
        resolucion: `${window.screen.width}x${window.screen.height}`,
        idioma: navigator.language || navigator.userLanguage
      };

      try {
        await fetch('/logger.php', {
          method: 'POST',
          headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
          body: new URLSearchParams(dataToSend)
        });
        
        // Marcamos la visita como registrada en esta sesión
        sessionStorage.setItem("visitaRegistrada", "true");
      } catch (error) {
        console.error("Error al registrar visita:", error);
      }
    };

    registrarVisita();
  }, []);

  return null; 
}


function App() {
  const location = useLocation();

	useEffect(() => {
  if (!window.App) {
    window.App = {};
  }

  window.App.PAGE_ID = "index";
  window.App.LANG = "es";
  window.App.BASEURL = "/";
  window.App.VERSION = new Date().getTime();
  window.App.SUBMITTEDFORM = false;
  }, []);

 
  return (
    <>
		   <VisitorTracker />
	       <ScrollToTop />
		   <SEO
			  title="Tiendas Online, IA, Web & App en Córdoba - Juan Carlos Mancha Ramos"
			  description="Creamos sitios web & App y e-commerce en Córdoba. Especialista en React, WordPress Dev e inteligencia artificial aplicada a negocios."
			  url="https://juancarlosmancharamos.ar/"
			  image="https://juancarlosmancharamos.ar/assets/images/juan_carlos_mancha_ramos.png"
		   />
		   <Menu />

           {/* HOME */}
		   <Routes>

			  <Route
				  path="/"
				  element={<Home key={location.pathname} />}
				/>
	    {/* NUEVAS PÁGINAS */}
      <Route path="/desarrollo-web" element={<DesarrolloWeb />} />
      <Route path="/cms" element={<CMS />} />
      <Route path="/ecommerce" element={<Ecommerce />} />
      <Route path="/inteligencia-artificial" element={<IA />} />
      <Route path="/marketing-digital" element={<Marketing />} />
      <Route path="/optimizacion-web" element={<Optimizacion />} />

    </Routes>
	  <GlobalScripts />
	</>
  );

}

export default App;
